const messages = {
  title: "Min personlige kontoutskrift",
  desc: "Her kan du se din personlige Bridgestone Plus-kontoutskrift med opptjente og brukte bonuspoeng. Vær oppmerksom på at det kan ta opptil 6 uker før poeng krediteres for dekkbestillingene dine, avhengig av kilde.",
  score: "Punktbalanse",
  regularPoints: "Vanlige poeng",
  boosterPoints: "Bonuspoeng",
  date: "Dato",
  supplySourceReason: "Kilde/Årsak til kjøp",
  article: "Artikkel",
  brand: "Merke",
  product: "Produkt",
  type: "Type",
  inch: "Tommer",
  season: "Sesong",
  amount: "Antall",
  standardPoints: "Poeng",
  boosterProduct: "Bonusprodukt",
  boosterSeason: "Bonussesong",
  otherActions: "Andre handlinger eller årsaker",
  totalPoints: "Totalt antall poeng",
  income: "Inntekt",
  spending: "Utgifter",
  lastMonth: "Sluttbalanse",
  loadMore: "Last inn 20 transaksjoner til",
  typeFilter: "Filtrer etter kilde",
  dateFilter: "Filtrer etter periode",
  customer_number: "Kundenummer",
  currentPoints: "Nåværende poeng",
  calculationDate: "Beregningsdato",
  positivePoints: "Positive poeng",
  negativePoints: "Allerede brukt",
  tyresAmount: "Antall dekk per år",
  pointsTotal: "Totalt poeng",
  currentPointState: "Nåværende punktstatus",
  currentKickbackState: "Nåværende cashback",
  pointsFromCurrentYear: "Legg til: poeng fra inneværende år ({year})",
  pointsAtRiskOfExpiry: "Poeng som må brukes innen 31.03.{year}",
  points: "Poeng",
  noDataFound: "Ingen data funnet",
  seasons: {
    summer: "Sommer",
    winter: "Vinter",
    all: "All sesong",
  },
};
export default {
  messages,
};
